import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetIpv4Group } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveIpv4Groups } from '../../shared/components';

export type UpdateIpv4GroupProps = {};

const UpdateIpv4Group: React.FC<UpdateIpv4GroupProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_grupoipv4);
  const returnUrlIpV4 = ROUTER_PATHS.configuracionRED.grupoIpv4Nav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetIpv4Group(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_grupoipv4) return <Navigate to={returnUrlIpV4} />;

  return (
    <SaveIpv4Groups titlePage="Editar Grupo IPv4" editIpv4Group={data.data} />
  );
};

export default UpdateIpv4Group;
